import type { CombinedError } from '@urql/vue'

export const useFailOnError = (errors: MaybeRef<CombinedError | undefined>) => {
  watch(
    () => unref(errors),
    (errors) => {
      if (!errors) return

      console.error(errors, errors.graphQLErrors)

      const firstError = errors.graphQLErrors[0]
      const message =
        // @ts-ignore: missing type on validation
        firstError?.extensions?.validation?.[0]?.[0] ?? firstError?.message

      throw createError({
        fatal: true,
        statusCode: 500,
        message: message ?? 'Error on fetching GQL',
        stack:
          errors.graphQLErrors
            .map((e: any) => e?.debugMessage || e?.message || e)
            .join('\n\n')
            + '\n\n'
            + Object.values(errors.graphQLErrors[0]?.extensions?.validation ?? {
            })
              .map(e => e[0])
              .join('\n\n'),
      })
    },
    {
      immediate: true,
    },
  )
}
